import React from "react";
import {
  Box,
  Card,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import {
  DATA_GRID_SX,
  DATA_GRID_SLOT_PROPS,
  DATA_GRID_LOCALE_TEXT,
  DATA_GRID_INITIAL_STATE,
  DATA_GRID_PAGE_SIZE_OPTIONS,
} from "../../../components/ui/dataGridStyles";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { useIncidencias } from "../hooks/useIncidencias";
import { generarColumnasIncidencias } from "../helpers/columns";
import FiltrosIncidencias from "../components/forms/FiltrosIncidencias";
import ModalIncidencia from "../components/modals/ModalIncidencia";
import IncidenciasMobileList from "../components/lists/IncidenciasMobileList";

/**
 * Página principal de gestión de incidencias
 * Orquestador que compone todos los subcomponentes del feature
 */
const ListaIncidencias = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"), { noSsr: true });

  const {
    incidencias,
    loading,
    soloAbiertas,
    showModal,
    incidenciaSeleccionada,
    loadingModal,
    toggleFiltro,
    handleEditarIncidencia,
    handleCerrarModal,
    handleConfirmarCambios,
  } = useIncidencias();

  const columns = generarColumnasIncidencias(handleEditarIncidencia);

  return (
    <Box id="incidencias" sx={{ width: "100%" }}>
      <Card sx={{ boxShadow: "0 2px 8px rgba(0,0,0,0.1)", borderRadius: 2 }}>
        {/* Header */}
        <Box sx={{ p: 3, pb: 2 }}>
          <Typography
            variant={isMobile ? "h6" : "h5"}
            sx={{
              fontWeight: 700,
              color: "#212529",
              mb: 0.5,
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <ReportProblemIcon sx={{ fontSize: isMobile ? 24 : 28 }} />
            Incidencias
          </Typography>
          <Typography variant="body2" sx={{ color: "#6c757d" }}>
            Gestiona las incidencias de pedidos, artículos y albaranes
          </Typography>

          {/* Filtros */}
          <FiltrosIncidencias
            soloAbiertas={soloAbiertas}
            onToggleFiltro={toggleFiltro}
          />
        </Box>

        {/* Contenido */}
        <Box sx={{ px: isMobile ? 2 : 3, pb: 3 }}>
          {!isMobile ? (
            <DataGrid
              rows={incidencias}
              columns={columns}
              localeText={DATA_GRID_LOCALE_TEXT}
              autoHeight
              loading={loading}
              disableRowSelectionOnClick
              initialState={DATA_GRID_INITIAL_STATE}
              pageSizeOptions={DATA_GRID_PAGE_SIZE_OPTIONS}
              slotProps={DATA_GRID_SLOT_PROPS}
              getRowClassName={(params) => {
                const tipo = params.row.tipoNote?.trim();
                if (tipo === "art") return "art";
                if (tipo === "ped") return "ped";
                return "";
              }}
              sx={DATA_GRID_SX}
            />
          ) : (
            <IncidenciasMobileList
              incidencias={incidencias}
              loading={loading}
              onEdit={handleEditarIncidencia}
            />
          )}
        </Box>
      </Card>

      {/* Modal de edición */}
      <ModalIncidencia
        show={showModal}
        onHide={handleCerrarModal}
        incidencia={incidenciaSeleccionada}
        onConfirm={handleConfirmarCambios}
        loading={loadingModal}
      />
    </Box>
  );
};

export default ListaIncidencias;
